import React from "react";
import { motion } from "framer-motion";
import { Award, Users, GraduationCap, Heart, ShieldCheck, Sparkle } from "lucide-react";

const badges = [
  { icon: Award, title: "Metodologia Cambridge", text: "Preparação para exames Cambridge com método internacional" },
  { icon: ShieldCheck, title: "Instituto de Formação", text: "Entidade certificada pela DGERT" },
  { icon: GraduationCap, title: "Professores Especializados", text: "Equipa qualificada e dedicada" },
  { icon: Users, title: "+300 Alunos", text: "Acompanhados com sucesso" },
  { icon: Heart, title: "Ambiente Acolhedor", text: "Seguro, motivador e premium" },
  { icon: Sparkle, title: "Acompanhamento Personalizado", text: "Cada aluno tratado como único" },
];

export const Credibility = () => {
  return (
    <section data-testid="credibility-section" className="section bg-white border-y border-stone-100">
      <div className="container-tight">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Porquê confiar em nós</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
            Uma equipa, <span className="italic text-bordeaux-700">uma missão.</span>
          </h2>
          <p className="mt-5 text-stone-600 max-w-2xl leading-relaxed">
            Combinamos rigor académico com inteligência emocional. Aqui, cada plano é construído à medida —
            porque cada aluno é único, com objetivos, ritmos e talentos próprios.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {badges.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`credibility-card-${i}`}
              className="group p-7 rounded-2xl bg-stone-50/70 border border-stone-100 hover:border-bordeaux-200 hover:bg-white transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(28,25,23,0.06)]"
            >
              <div className="h-12 w-12 rounded-xl bg-bordeaux-50 text-bordeaux-700 flex items-center justify-center group-hover:bg-bordeaux-700 group-hover:text-white transition-colors">
                <b.icon size={22} strokeWidth={1.5} />
              </div>
              <div className="mt-5 font-display text-xl text-stone-900">{b.title}</div>
              <div className="mt-1.5 text-sm text-stone-600 leading-relaxed">{b.text}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
